<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "tariffs",
    cardSetLink: "tariffs",
    item: null,
    fields: [
      {
        key: "title",
        label: "Название",
        isMultiLang: true,
        type: 'field',
      },
      {
        key: "description",
        label: "Краткое описание",
        isMultiLang: true,
        type: 'textarea',
      },
      {
        key: "price",
        label: "Стоимость",
        type: "field",
        textType: "number",
      },
      {
        key: "period",
        label: "Период (месяцев)",
        type: "field",
        textType: "number",
      },
      // {
      //   key: "client_count",
      //   label: "Количество детей",
      //   type: "field",
      //   textType: "number",
      // },
      {
        key: "is_active",
        label: "Период (месяцев)",
        type: "checkbox",
        textType: "number",
      },

    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>

</style>
